import * as React from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import cn from 'classnames'
import * as styles from './styles.module.css'

const CategorySection = () => {
  const { t } = useTranslation()

  const renderCategory = () => {
    const categoryList = []
    // eslint-disable-next-line no-plusplus
    for (let i = 1 ; i <= 6 ; i++) {
      categoryList.push(`landing.categoryService${i}`)
    }

    return (
      <>
        {
          categoryList.map(s => 
            <li key={s}>
              {t(s)}
            </li>
          )
        }
      </>
    )
  }
  return (
    <>
      <div className={cn(styles.sectionRoot)}>
        <h3>
          {t('landing.categoryTitle')}
        </h3>
        <span>{t('landing.categorySubTitle')}</span>
        <ul>
          {
            renderCategory()
          }
        </ul>
      </div>
    </>
  )
}

export default CategorySection